import Main from "src/components/Main/Main";

import { GlobalSearch } from "src/components/GlobalSearch/GlobalSearch";
import Cooperations from "../components/NewComponents/Cooperations";

const ExamHome = () => {
	return (
		<div>
			<GlobalSearch className="mb-12" />
			<Cooperations />
			<Main />
		</div>
	);
};

export default ExamHome;
